export default __webpack_public_path__ + "static/media/kindimg.6f6626e1.png";